import axios from 'axios';
import { Constants } from '../lib/const/constants';
import { encryptPayload } from './encryption';

export const initiateWalletTransaction = async ({
  lastTransaction,
  beneficiaries,
  currency,
  currencyid,
  navigate,
  ref,
  setButtonLoading,
  setcurrencyCloudBalance,
  setclearBankBalance,
  setclearBankConfiguration,
  toast,
}) => {
  setButtonLoading(true);
  sessionStorage.removeItem('transfer_reason');

  const repeat_contactId = localStorage.getItem('repeat_contactId');
  if (!repeat_contactId) {
    toast.error('Contact ID not found for repeat transaction.');
    setButtonLoading(false);
    return;
  }

  const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
  const token = sessionStorage.getItem('login_token');
  const workspace = sessionStorage.getItem('login_workspaces');
  const parsedWorkspace = JSON.parse(workspace);
  const login_full_name = parsedWorkspace[0].name;
  const staff_login_id = sessionStorage.getItem('staff_login_id');
  const transferReason = lastTransaction.meta_data.reason;

  if (!token || !login_workspaces_id) {
    return;
  }
  if (!lastTransaction || !beneficiaries.length) {
    console.log('Data not ready yet');
    setButtonLoading(false);
    return;
  }

  const beneficiaryId =
    lastTransaction?.meta_data?.beneficiaryId ||
    lastTransaction?.meta_data?.beneficiary_id;
  const bene = beneficiaries.find(
    (b) => String(b.id) === String(beneficiaryId),
  );

  if (!bene) {
    toast.error('Beneficiary not found.');
    setButtonLoading(false);
    return;
  }

  try {
    const balanceUrl =
      Constants.BASE_URL +
      'API-FX-231-GET-WALLET-BALANCES/' +
      login_workspaces_id +
      '?currency=' +
      currency;

    const resp = await axios.get(balanceUrl, {
      headers: {
        Authorization: 'Bearer ' + JSON.parse(token),
        fx_key: Constants.SUBSCRIPTION_KEY,
      },
    });

    const balArray = Object.values(resp.data);
    const usedbalances = resp.data.used_balances;

    const freshCurrencyCloudBalance = resp.data.currency_cloud_account_balance;
    const freshClearBankBalance = resp.data.clear_bank_account_balance;

    setcurrencyCloudBalance(freshCurrencyCloudBalance);
    setclearBankBalance(freshClearBankBalance);
    setclearBankConfiguration(resp.data.fees_configuration);

    balArray.pop();
    balArray.pop();
    balArray.pop();
    balArray.pop();

    const matchedBalance = balArray.find(
      (balance) => balance.currency === currency,
    );
    if (!matchedBalance) {
      toast.error('No matching balance found for currency.');
      setButtonLoading(false);
      return;
    }

    let usedbalance = 0;
    const key = getKeyByValue(Object.keys(usedbalances), currency);
    if (key != null && key !== '' && key !== 'undefined') {
      usedbalance = Object.values(usedbalances)[key];
    }

    let availableBalance = parseFloat(
      matchedBalance.balance - usedbalance,
    ).toFixed(2);
    if (
      availableBalance < 0 ||
      availableBalance == null ||
      availableBalance === '' ||
      availableBalance === 'NaN'
    ) {
      availableBalance = 0;
    }
    const encryptedPayload = await encryptPayload({
        contact_id: repeat_contactId,
        workspace_id: login_workspaces_id,
        reason_code: transferReason,
        full_name: bene.display_name.toUpperCase(),
        sort_code: bene.code,
        createTransaction: true,
        currency: currency,
        account_number: bene.bank_account_number,
        type: 'local',
        currency_cloud_balance: freshCurrencyCloudBalance,
        clear_bank_balance: freshClearBankBalance,
        total_balance: availableBalance,
        beneficiaryId: bene.id,
        reference:
          ref && typeof ref === 'string' && ref !== '' ? ref : login_full_name,
        reason: transferReason,
        staff_login_id: staff_login_id,
        status: 'waiting for funds',
        flow: 'sendFlow',
        platform: 'web',extraParamValidation: 'trustedfromweb'
      });
    const sendFlowResp = await axios.post(
      Constants.BASE_URL + 'API-FX-240-SEND-FLOW',
      encryptedPayload
      ,
      {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
          Authorization: 'Bearer ' + JSON.parse(token),
        },
      },
    );

    const transactionId = sendFlowResp?.data?.data?.id;
    console.log('transactionId', transactionId);

    await transferMoney({
      transactionId,
      lastTransaction,
      beneficiaries,
      currency,
      currencyid,
      navigate,
      toast,
      setButtonLoading,
      contactId: repeat_contactId,
    });
  } catch (err) {
    const errorMessage =
      err.response?.data?.message ||
      err.message ||
      'Something went wrong. Please try again.';
    toast.error(errorMessage);
    setButtonLoading(false);
  }
};

function getKeyByValue(object, value) {
  return Object.keys(object).find((key) => object[key] === value);
}

export const transferMoney = async ({
  transactionId,
  lastTransaction,
  beneficiaries,
  currency,
  currencyid,
  navigate,
  toast,
  setButtonLoading,
  contactId,
}) => {
  setButtonLoading(true);
  const token = sessionStorage.getItem('login_token');
  const transferReason = lastTransaction.meta_data.reason;

  if (!token) {
  return;
}
  if (!lastTransaction || !beneficiaries.length) {
    console.log('Data not ready yet');
    setButtonLoading(false);
    return;
  }

  try {
    const encryptedPayload = await encryptPayload({
        reason: transferReason,
        transactionId: transactionId,
        platform: 'web',
        extraParamValidation: 'trustedfromweb'
      });
    const resp = await axios.post(
      Constants.BASE_URL + ' API-FX-182-DIRECTTRANSFER-SUBMITPAYMENT',
      encryptedPayload,
      {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
          Authorization: 'Bearer ' + JSON.parse(token),
        },
      },
    );

    console.log('submitPayment response:', resp.data);

    const beneficiaryId =
      lastTransaction?.meta_data?.beneficiaryId ||
      lastTransaction?.meta_data?.beneficiary_id;
    const bene = beneficiaries.find(
      (b) => String(b.id) === String(beneficiaryId),
    );

    if (!bene) {
      toast.error('Beneficiary not found.');
      setButtonLoading(false);
      return;
    }

    const conversionMeta = lastTransaction?.meta_data?.conversion_meta;

    const send_amount =
      conversionMeta?.conversion_client_sell_amount ||
      lastTransaction.amount ||
      '';

    const currencyToId = {
      GBP: 231,
      INR: 105,
      USD: 234,
      EUR: 2,
      AUD: 13,
    };

    const sellCurrency =
      currencyToId[conversionMeta?.conversion_sell_currency] || 231;
    const buyCurrency =
      currencyToId[conversionMeta?.conversion_buy_currency] || 105;
    const storedRate = conversionMeta?.conversion_client_rate || null;

    const liveRate = await getRepeatExchangeRate(
      send_amount,
      sellCurrency,
      buyCurrency,
    );
    const repeat_exchangeRate = liveRate ?? storedRate;

    console.log(
      'live rate:',
      liveRate,
      '| stored rate:',
      storedRate,
      '| using:',
      repeat_exchangeRate,
    );

    setButtonLoading(false);

    navigate('/payment-method', {
      state: {
        name: bene.display_name.toUpperCase(),
        ifsc: bene.code,
        account: bene.bank_account_number,
        type: bene.type,
        id: bene.id,
        bank_account_name: bene.display_name.toUpperCase(),
        currencyid: currencyid,
        currency: currency,
        amount: send_amount,
        bank_account_id: bene.bank_account_id,
        country: bene.country,
        bene_type: bene.bene_type,
        bank_type: bene.bank_type,
        contactId: contactId,
        exchangeRate: repeat_exchangeRate,
        from_currency: lastTransaction.currency,
        from_amount: send_amount,
        transactionId: transactionId,
      },
    });
  } catch (err) {
    console.error('transferMoney error:', err.response || err);
    setButtonLoading(false);
  }
};

export const beneficiaryList = async ({ currencyid, setBeneficiaries }) => {
  const token = sessionStorage.getItem('login_token');
  const workspaceId = sessionStorage.getItem('login_workspaces_id');

  if (!token || !workspaceId) {
    return;
  }

  let allBeneficiaries = [];

  if (currencyid == 231) {
    const clear = await getClearbankBene(token, workspaceId);
    const cc = await getCCBene(token, workspaceId);
    allBeneficiaries = [...clear, ...cc];
  } else {
    allBeneficiaries = await getCCBene(token, workspaceId);
  }

  setBeneficiaries(allBeneficiaries);
};

export const getClearbankBene = async (token, workspaceId) => {
  if (!token || !workspaceId) {
    return [];
  }
  const result = [];
  const encryptedPayload = await encryptPayload({ workspace_id: workspaceId,platform: 'web',
          extraParamValidation: 'trustedfromweb' });
  const resp = await axios.post(
    Constants.BASE_URL + 'API-FX-191-CLEAR-BANK-LIST-BENEFICIARY',
    encryptedPayload,
    {
      headers: {
        fx_key: Constants.SUBSCRIPTION_KEY,
        Authorization: 'Bearer ' + JSON.parse(token),
      },
    },
  );

  resp.data.data.forEach((element) => {
    result.push({
      id: element.id,
      display_name: element.beneficiaryName,
      bank_account_number: element.banks[0].accountNumber,
      country_flag: Constants.FXMASTER_BASE_URL + 'flags/UK.png',
      code: element.banks[0].sortCode,
      bene_type: element.type,
      bank_type: 'clear_bank',
    });
  });

  return result;
};

export const getCCBene = async (token, workspaceId) => {
  if (!token || !workspaceId) {
    return [];
  }
  try {
    const response = await axios.get(
      `${Constants.BASE_URL}API-FX-126-ListBeneficiary`,
      {
        params: { workspace_id: workspaceId, reference_type: 'money_transfer' },
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
          Authorization: `Bearer ${JSON.parse(token)}`,
        },
      },
    );

    const countryCodeMapping = {
      105: 'ifsc_code',
      234: 'aba_number',
      231: 'sort_code',
      38: 'branch_code',
      13: 'bsb_number',
      2: 'iban_number',
      1: 'iban_number',
      55: 'iban_number',
      114: 'iban_number',
      115: 'iban_number',
      129: 'iban_number',
      158: 'iban_number',
      177: 'iban_number',
      198: 'iban_number',
      59: 'iban_number',
      95: 'iban_number',
      100: 'iban_number',
      193: 'iban_number',
      249: 'iban_number',
    };

    const beneficiaryLists = response.data.data
      .filter((el) => countryCodeMapping[el.meta.bank_country])
      .map((el) => ({
        id: el.id,
        display_name: el.display_name,
        bank_account_number: el.meta.bank_account_number || el.meta.iban,
        country_flag: el.country_flag,
        avatar: el.avatar || 'https://uat.fxmaster.co.uk/dist/images/user.png',
        code:
          el.meta.bic_number ??
          el.meta.aba_number ??
          el.meta.sort_code ??
          el.meta.branch_code ??
          el.meta.bsb_number ??
          el.meta.bank_code ??
          el.meta.ifsc_code ??
          el.meta.routing_code_value_1,
        bank_code_type: el.meta.bank_code_type,
        type: el.type,
        country: el.meta.beneficiary_address,
        bank_account_name: el.meta.bank_account_name,
        bank_account_id: '',
        bene_type: el.type,
        bank_type: 'currency_cloud',
      }));

    return beneficiaryLists;
  } catch (err) {
    console.error('getCCBene error:', err);
    return [];
  }
};

const getRepeatExchangeRate = async (amount, sellCurrencyId, buyCurrencyId) => {
  try {
    const token = sessionStorage.getItem('login_token');
    const staff_login_id = sessionStorage.getItem('staff_login_id');
    const workspaceId = sessionStorage.getItem('login_workspaces_id');
    const encryptedPayload = await encryptPayload({
        sell_currency_country_id: sellCurrencyId,
        buy_currency_country_id: buyCurrencyId,
        amount: parseFloat(parseFloat(amount).toFixed(2)),
        workspace_id: workspaceId,
        type: 'sell',
        staff_login_id: staff_login_id,
        platform: 'web',
        extraParamValidation: 'trustedfromweb'
      })
    const response = await axios.post(
      Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
      encryptedPayload,
      {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
          Authorization: 'Bearer ' + JSON.parse(token),
        },
      },
    );

    return response.data.data.meta.client_rate;
  } catch (error) {
    if (error.response) {
      console.error(
        'API error response:',
        error.response.status,
        error.response.data,
      );
    } else {
      console.error('Network/unexpected error:', error.message);
    }
    return null;
  }
};

export const fetchAndStoreLatestTransaction = async () => {
  const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
  const login_token = sessionStorage.getItem('login_token');

  const today = new Date();
  const from = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 100}`;
  const to = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

  try {
    const response = await axios.get(
      `${Constants.BASE_URL}API-FX-180-CONVERSIONLIST/${login_workspaces_id}?page=0&from=${from}&to=${to}`,
      {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(login_token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      },
    );
    const otherTransactions = response.data.otherTransactions;
    if (Array.isArray(otherTransactions) && otherTransactions.length > 0) {
      // const latest = otherTransactions[0];

      const debitTransactions = otherTransactions
        .filter((t) => t.type === 'debit')
        .slice(0, 3);

      const mapped = debitTransactions.map((latest) => {
        const meta = JSON.parse(latest.meta || '{}');
        // const latestTransactionData = {
        //   id: latest.id,
        //   name: latest.type === 'debit' ? meta.second_beneficiary_name : meta.sender_name,
        //   amount: meta.conversion_meta?.conversion_client_sell_amount || latest.amount,
        //   currency: meta.conversion_meta?.conversion_sell_currency || latest.settled_currency,
        //   date: latest.created_at,
        //   status: latest.status,
        //   payment_method: latest.payment_method,
        //   transfer_reason: meta.conversion_meta?.reason,
        //   last_transaction: latest,
        //   meta_data: meta,
        //   contact_id: meta?.conversion_meta?.conversion_id || null,
        // };

        return {
          id: latest.id,
          name: meta.second_beneficiary_name,
          amount:
            meta.conversion_meta?.conversion_client_sell_amount ||
            latest.amount,
          currency:
            meta.conversion_meta?.conversion_sell_currency ||
            latest.settled_currency,
          date: latest.created_at,
          status: latest.status,
          payment_method: latest.payment_method,
          transfer_reason: meta.conversion_meta?.reason,
          last_transaction: latest,
          meta_data: meta,
          contact_id: meta?.conversion_meta?.conversion_id || null,
        };
      });

      localStorage.setItem('latestTransactions', JSON.stringify(mapped));
      return mapped;
    }
  } catch (err) {
    console.error('Failed to fetch latest transaction:', err);
  }
  return null;
};

// Send Money View Screen Repeat Transactions functionality
export const repeatTransaction = async ({
  txn,
  currencyid,
  navigate,
  setButtonLoading,
  setcurrencyCloudBalance,
  setclearBankBalance,
  setclearBankConfiguration,
  toast,
}) => {
  try {
    const token = sessionStorage.getItem('login_token');
    const workspaceId = sessionStorage.getItem('login_workspaces_id');
    const staff_login_id = sessionStorage.getItem('staff_login_id');

    const conversionMeta = txn?.meta_data?.conversion_meta;

    const send_amount =
      conversionMeta?.conversion_client_sell_amount || txn?.amount;

    const sellCurrencyId =
      conversionMeta?.conversion_sell_currency === 'GBP' ? 231 : '';

    const buyCurrencyId =
      conversionMeta?.conversion_buy_currency === 'INR' ? 105 : '';
    const encryptedPayload = await encryptPayload({
        sell_currency_country_id: sellCurrencyId,
        buy_currency_country_id: buyCurrencyId,
        amount: parseFloat(parseFloat(send_amount).toFixed(2)),
        workspace_id: workspaceId,
        type: 'sell',
        staff_login_id: staff_login_id,
        platform: 'web',
        extraParamValidation: 'trustedfromweb'
      })
    const convResp = await axios.post(
      Constants.BASE_URL + 'API-FX-163-CONVERTRATES',
      encryptedPayload,
      {
        headers: {
          fx_key: Constants.SUBSCRIPTION_KEY,
          Authorization: 'Bearer ' + JSON.parse(token),
        },
      },
    );

    const freshContactId = convResp.data.contact_id;

    if (!freshContactId) {
      toast.error('Contact ID not found');
      return;
    }

    localStorage.setItem('repeat_contactId', freshContactId);

    const bene = {
      id: txn?.meta_data?.beneficiaryId,
      display_name: txn?.name,
      bank_account_number:
        txn?.meta_data?.second_beneficiary_bank_account_number,
      code: txn?.meta_data?.second_beneficiary_bank_code,
    };

    await initiateWalletTransaction({
      lastTransaction: txn,
      beneficiaries: [bene], //  pass as array
      currency: txn.currency,
      currencyid,
      navigate,
      ref: '',
      setButtonLoading,
      setcurrencyCloudBalance,
      setclearBankBalance,
      setclearBankConfiguration,
      toast,
    });
  } catch (err) {
    console.error('repeatTransaction error:', err);
    toast.error(err?.response?.data?.message || 'Repeat failed');
  }
};
// Send Money Download Receipt Functionality
export const downloadReceipt = async (id, setdownloadId) => {
  setdownloadId(id);
  const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
  await axios
    .post(
      Constants.BASE_URL + 'API-FX-208-DOWNLOAD-TRANSACTION-RECEIPT',
      {
        id: id,
        workspace_id: login_workspaces_id,
      },
      {
        headers: {
          'Content-Type': 'application/json',
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      },
    )
    .then((resp) => {
      window.open(JSON.parse(resp.data.document).url, '_blank');
      setdownloadId(0);
    })
    .catch((err) => {
      setdownloadId(0);
      console.log(err.response);
    });
};

export const fetchTransactionById = async (transactionId) => {
  const login_workspaces_id = sessionStorage.getItem('login_workspaces_id');
  const login_token = sessionStorage.getItem('login_token');

  const today = new Date();
  const from = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() - 100}`;
  const to = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;

  try {
    const response = await axios.get(
      `${Constants.BASE_URL}API-FX-180-CONVERSIONLIST/${login_workspaces_id}?page=0&from=${from}&to=${to}`,
      {
        headers: {
          Authorization: 'Bearer ' + JSON.parse(login_token),
          fx_key: Constants.SUBSCRIPTION_KEY,
        },
      },
    );

    const otherTransactions = response.data.transactions;
    if (!Array.isArray(otherTransactions)) return null;

    const match = otherTransactions.find(
      (t) => String(t.id) === String(transactionId)
    );
    console.log("mat", match);
    if (!match) return null;

    const meta = JSON.parse(match.meta || '{}');

    return {
      id: match.id,
      name: meta.second_beneficiary_name || '',
      amount: meta.conversion_meta?.conversion_client_sell_amount || match.amount,
      currency: meta.conversion_meta?.conversion_sell_currency || match.settled_currency,
      date: match.created_at,
      status: match.status,
      type: match.type,
    };
  } catch (err) {
    console.error('fetchTransactionById error:', err);
    return null;
  }
};
